export const TEMPORARY_ID_PREFIX = 'NEW_';

export const createTemporaryId = () => TEMPORARY_ID_PREFIX + Date.now();

export const isTemporaryId = (id) => id && typeof id === 'string' && id.indexOf(TEMPORARY_ID_PREFIX) === 0;

export const idSortFunc = (firstRecord, secondRecord) => {
    let result;
    const firstRecordId = firstRecord.id;
    const secondRecordId = secondRecord.id;
    if (typeof firstRecordId === 'number' && typeof secondRecordId === 'number') {
        result = firstRecordId - secondRecordId;
    } else {
        result = String(firstRecordId).localeCompare(String(secondRecordId));
    }
    return result;
};
